export default "__VITE_ASSET__C_GSBa$6__"